var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-dialog',_vm._g({ref:"dialog",attrs:{"padded":false}},_vm.$listeners),[_c('div',{staticClass:"message r-text-regular text-riseup-blue r-text-bold text-center"},[_vm._v(_vm._s(_vm.statusMessage))]),_c('animated-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }